/**
 * Headers for API calls: Bearer token plus legacy `pxtoken` header with the same value
 * (many Carbon Voice routes historically used the `pxtoken` name).
 */
export function buildAuthHeaders(accessToken) {
  if (!accessToken) {
    return {};
  }
  return {
    Authorization: `Bearer ${accessToken}`,
    PXToken: accessToken,
    pxtoken: accessToken,
  };
}
